module.exports = __webpack_public_path__ + "media/images/categories/icon_cat23-c5324938d4b4f2e61c883c12f5ca11fd.svg";